import React, { Component } from "react";
import { Button, Tabs } from "antd";
import "./search-result.scss";
import XuatThongTin from "./XuatDuLieu";
import StaticClass from "../../../../utils/staticClass";
import { LocalStore } from '../../../../utils/LocalStore/index';
export default class SearchResult extends Component {
  constructor(props) {
    super(props);

    this.state = {
      // activeTab: "ThuaDat",
      isShowLocation: false,
    };

    this.listTitleThuaDat = [
      "Tỉnh thành",
      "Quận/Huyện",
      "Phường/Xã",
      "Số hiệu thửa đất",
      "Số tờ bản đồ",
      "Diện tích (m²)",
      "Loại đất",
    ];

    this.listValueThuaDat = [
      "TenTinh",
      "TenHuyen",
      "TenPhuong",
      "SoThua",
      "SoToBD",
      "DienTich",
      "LoaiDat",
    ];

    this.listTitleKienTruc = [
      "Tên khu vực",
      "Chỉ giới XD",
      "Tầng cao XD",
      "Chiều cao tầng",
      "Cốt nền",
      "Quyết định khác",
      "Mật độ xây dựng",
    ];

    this.listValueKienTruc = [
      "TenKhuVuc",
      "ChiGioiXD",
      "TangCaoXD",
      "ChieuCaoTang",
      "CotNen",
      "QDKhac",
      "MatDoXD",
    ];

    this.listTitleQuyHoach = [
      "Tên dự án",
      "Quận/Huyện",
      "Phường/Xã",
      "Diện tích (ha)",
      "Chủ đầu tư",
      "Điều hành dự án",
      "Quyết định pháp lý",
      "Năm ra QĐ",
      "Năm quy hoạch",
    ];

    this.listValueQuyHoach = [
      "Tendoan",
      "TENHUYEN",
      "TenPhuong",
      "DienTich",
      "Chudautu",
      "Dieuhanhduan",
      "Quyetdinhphaply",
      "NamraQDphaply",
      "NamQH",
    ];

    this.listTitleQuyHoachPhanKhu = [
      "Mã phân khu",
      "Tên phân khu",
      "Mã quy hoạch chung",
      "Diện tích (ha)",
      "Số quyết định pháp lý",
      "Năm ra quyết định pháp lý",
      "Cơ quan phê duyệt dự án",
      "Vị trí",
      "Năm quy hoạch",
      "Tình trạng",
    ];

    this.listValueQuyHoachPhanKhu = [
      "MaPhanKhu",
      "TenPhanKhu",
      "MaQHChung",
      "DienTich",
      "QuyetDinhPhapLy",
      "NamRaQDPL",
      "CoQuanpheDuyet",
      "ViTri",
      "NamQH",
      "TinhTrang",
    ];

    this.listTienDo = [
      "-",
      "Cơ bản hoàn thành",
      "Đang triển khai",
      "Chưa triển khai",
      "Chậm triển khai",
    ];
  }

  componentDidMount() {
    if (this.props.dataThuaDat) {
      this.setState({
        activeTab: "ThuaDat",
      });
    } else {
      if (this.props.dataKienTruc) {
        this.setState({
          activeTab: "KienTruc",
        });
      } else {
        if (this.props.dataQuyHoach || this.props.dataQuyHoachPhanKhu) {
          this.setState({
            activeTab: "QuyHoach",
          });
        }
      }
    }
  }

  
  componentDidUpdate(prevProps, prevState) {
    if(prevProps.dataThuaDat !== this.props.dataThuaDat){
      this.setState({
        isShowLocation: false
      })
    }
  }
  

  changeTab = (id) => {
    this.setState({ activeTab: id });
  };

  showLocation(){
    if(this.state.isShowLocation){
      this.props.hidePoint(this.props.dataThuaDat)
    }else{
      this.props.showPoint(this.props.dataThuaDat)
    }
    this.setState({
      isShowLocation: !this.state.isShowLocation
    })
  }

  render() {
    const { dataThuaDat, dataKienTruc, dataQuyHoach } = this.props;
    let Quyhoach = undefined;
    if (dataQuyHoach && dataQuyHoach.ChuDauTu) {
      Quyhoach = {
        ...dataQuyHoach,
        Chudautu: dataQuyHoach.ChuDauTu,
      };
    } else {
      Quyhoach = dataQuyHoach;
    }

    let QuyHoachPhanKhu = undefined;
    if (
      this.props.dataQuyHoachPhanKhu &&
      this.props.dataQuyHoachPhanKhu.NamRaQDPL
    ) {
      QuyHoachPhanKhu = {
        ...this.props.dataQuyHoachPhanKhu,
        NamRaQDPL: StaticClass.formatDate(
          this.props.dataQuyHoachPhanKhu.NamRaQDPL
        ),
      };
    } else {
      QuyHoachPhanKhu = this.props.dataQuyHoachPhanKhu;
    }

    if (QuyHoachPhanKhu && QuyHoachPhanKhu.TinhTrang) {
      QuyHoachPhanKhu.TinhTrang = this.listTienDo[
        `${QuyHoachPhanKhu.TinhTrang}`
      ];
    }
    return (
      <div className="search-result">
        <div className="header font-size-16">
          Thông tin
          <i
            className="fas fa-times icon-close"
            onClick={() => {
              this.props.close();
            }}
          ></i>
        </div>

        {/* <div className="tab">
          <div
            className={
              this.state.activeTab === "ThuaDat"
                ? "tab-button tab-button-left"
                : "tab-button"
            }
            onClick={() => this.changeTab("ThuaDat")}
          >
            TT Thửa đất
          </div>

          <div
            className={
              this.state.activeTab === "KienTruc"
                ? "tab-button tab-button-center"
                : "tab-button"
            }
            onClick={() => this.changeTab("KienTruc")}
          >
            TT Kiến trúc
          </div>

          <div
            className={
              this.state.activeTab === "QuyHoach"
                ? "tab-button tab-button-right"
                : "tab-button"
            }
            onClick={() => this.changeTab("QuyHoach")}
          >
            TT Quy hoạch
          </div>
        </div> */}

        <Tabs defaultActiveKey="1">
          <Tabs.TabPane
            key="1"
            tab={
              <div
                style={{
                  width: "107px",
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                {" "}
                TT Thửa đất
              </div>
            }
          >
            <div className="search-result-body">
              {dataThuaDat ? (
                <div>
                  {this.listTitleThuaDat.map((e, i) => (
                    <div style={{ display: "flex" }} key={i}>
                      <div className="left-col text">{e}:</div>

                      <div className="right-col text">
                        {this.props.dataThuaDat[`${this.listValueThuaDat[i]}`]
                          ? i === 5 
                            ? StaticClass.formatPrice(this.props.dataThuaDat[`${this.listValueThuaDat[i]}`])
                            : this.props.dataThuaDat[`${this.listValueThuaDat[i]}`]
                          : "-"}
                      </div>
                    </div>
                  ))}

                  <div style={{ display: "flex", justifyContent: "center" }}>
                    <Button
                      type="primary"
                      className="search-result-button"
                      onClick={() => {
                        XuatThongTin(this.props);
                      }}
                    >
                      Xuất thông tin
                    </Button>

                    <Button
                      type="primary"
                      className="search-result-button"
                      onClick={this.props.search}
                    >
                      Tìm kiếm
                    </Button>

                    { localStorage.loginSession && <Button
                      type="primary"
                      className="search-result-button"
                      onClick={()=>this.showLocation()}
                    >
                      {this.state.isShowLocation  ? "Ẩn toạ độ" : "Hiện toạ độ"}
                    </Button>}
                  </div>
                </div>
              ) : (
                <>
                  <div className="text-no-data">Chưa có thông tin</div>

                  <div style={{ display: "flex", justifyContent: "center" }}>
                    <Button
                      type="primary"
                      className="search-result-button"
                      onClick={this.props.search}
                    >
                      Tìm kiếm
                    </Button>
                  </div>
                </>
              )}
            </div>

            {this.state.isShowLocation ? (
              <div
                style={{
                  textAlign: "center",
                  maxHeight: "300px",
                  overflow: "auto",
                  // marginBottom: "10px",
                  padding: "10px"
                }}
              >
                <table style={{ width: "100%" }}>
                  <tbody>
                    <tr>
                      <th
                        style={{ border: "1px solid #a3a3a3", width: "80px" }}
                      >
                        Số hiệu góc thửa
                      </th>
                      <th style={{ border: "1px solid #a3a3a3" }}>X(m)</th>
                      <th style={{ border: "1px solid #a3a3a3" }}>Y(m)</th>
                    </tr>
                    {this.props.dataThuaDat &&
                      this.props.dataThuaDat.SHAPE &&
                      this.props.dataThuaDat.SHAPE.length === undefined &&
                      this.props.dataThuaDat.SHAPE.points.map((o, index, arr) => {
                        if (index < this.props.dataThuaDat.SHAPE.points.length - 1)
                          return (
                            <tr key={index}>
                              <td style={{ border: "1px solid #a3a3a3" }}>
                                {index + 1}
                              </td>
                              <td style={{ border: "1px solid #a3a3a3" }}>
                                {StaticClass.formatNumberFloat(o.x)}
                              </td>
                              <td style={{ border: "1px solid #a3a3a3" }}>
                                {StaticClass.formatNumberFloat(o.y)}
                              </td>
                            </tr>
                          );
                      })}
                    {this.props.dataThuaDat &&
                      this.props.dataThuaDat.SHAPE &&
                      this.props.dataThuaDat.SHAPE.length &&
                      this.props.dataThuaDat.SHAPE.map((e, index1) => {
                        return (
                          <>
                            {e.points.map((p, index, arr) => {
                              return (
                                <tr key={index}>
                                  <td style={{ border: "1px solid #a3a3a3" }}>
                                    {index === arr.length - 1 ? 1 : index + 1}
                                  </td>
                                  <td style={{ border: "1px solid #a3a3a3" }}>
                                    {StaticClass.formatNumberFloat(p.y)}
                                  </td>
                                  <td style={{ border: "1px solid #a3a3a3" }}>
                                    {StaticClass.formatNumberFloat(p.x)}
                                  </td>
                                </tr>
                              );
                            })}
                          </>
                        );
                      })}
                  </tbody>
                </table>
              </div>
            ) : null}
          </Tabs.TabPane>

          <Tabs.TabPane
            key="2"
            tab={
              <div
                style={{
                  width: "106px",
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                {" "}
                TT Kiến trúc
              </div>
            }
          >
            <div className="search-result-body">
              {dataKienTruc ? (
                <div>
                  {this.listTitleKienTruc.map((e, i) => (
                    <div style={{ display: "flex" }} key={i}>
                      <div className="left-col text">{e}:</div>

                      <div className="right-col text">
                        {this.props.dataKienTruc[`${this.listValueKienTruc[i]}`]
                          ? this.props.dataKienTruc[
                              `${this.listValueKienTruc[i]}`
                            ]
                          : "-"}
                      </div>
                    </div>
                  ))}

                  <div style={{ display: "flex", justifyContent: "center" }}>
                    <Button
                      type="primary"
                      className="search-result-button"
                      onClick={() => {
                        XuatThongTin(this.props);
                      }}
                    >
                      Xuất thông tin
                    </Button>
                    <Button
                      type="primary"
                      className="search-result-button"
                      onClick={this.props.search}
                    >
                      Tìm kiếm
                    </Button>
                  </div>
                </div>
              ) : (
                <>
                  <div className="text-no-data">Chưa có thông tin</div>

                  <div style={{ display: "flex", justifyContent: "center" }}>
                    <Button
                      type="primary"
                      className="search-result-button"
                      onClick={this.props.search}
                    >
                      Tìm kiếm
                    </Button>
                  </div>
                </>
              )}
            </div>
          </Tabs.TabPane>

          <Tabs.TabPane
            key="3"
            tab={
              <div
                style={{
                  width: "107px",
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                {" "}
                TT Quy hoạch
              </div>
            }
          >
            <div className="search-result-body">
              {this.props.dataQuyHoach || this.props.dataQuyHoachPhanKhu ? (
                <>
                  {dataQuyHoach && (
                    <div>
                      <div
                        style={{
                          fontFamily: "Roboto",
                          fontSize: "16px",
                          fontStyle: "normal",
                          fontWeight: 500,
                          color: "#1F86EB",
                        }}
                      >
                        Thông tin quy hoạch chi tiết 1/500
                      </div>
                      {this.listTitleQuyHoach.map((e, i) => (
                        <div style={{ display: "flex" }} key={i}>
                          <div className="left-col text">{e}:</div>

                          <div className="right-col text">
                            {Quyhoach[`${this.listValueQuyHoach[i]}`]
                              ? i === 3
                                ? StaticClass.formatPrice(Quyhoach[`${this.listValueQuyHoach[i]}`])
                                : Quyhoach[`${this.listValueQuyHoach[i]}`]
                              : "-"}
                          </div>
                        </div>
                      ))}
                    </div>
                  )}

                  {this.props.dataQuyHoachPhanKhu && (
                    <div>
                      <div
                        style={{
                          fontFamily: "Roboto",
                          fontSize: "16px",
                          fontStyle: "normal",
                          fontWeight: 500,
                          color: "#1F86EB",
                        }}
                      >
                        Thông tin quy hoạch phân khu 1/5000
                      </div>
                      {this.listTitleQuyHoachPhanKhu.map((e, i) => (
                        <div style={{ display: "flex" }} key={i}>
                          <div className="left-col text">{e}:</div>

                          <div className="right-col text">
                            {QuyHoachPhanKhu[
                              `${this.listValueQuyHoachPhanKhu[i]}`
                            ]
                              ? i === 3 
                                ? StaticClass.formatPrice(QuyHoachPhanKhu[`${this.listValueQuyHoachPhanKhu[i]}`])
                                : QuyHoachPhanKhu[`${this.listValueQuyHoachPhanKhu[i]}`]
                              : "-"}
                          </div>
                        </div>
                      ))}
                    </div>
                  )}

                  <div style={{ display: "flex", justifyContent: "center" }}>
                    <Button
                      type="primary"
                      className="search-result-button"
                      onClick={() => {
                        XuatThongTin(this.props);
                      }}
                    >
                      Xuất thông tin
                    </Button>
                    <Button
                      type="primary"
                      className="search-result-button"
                      onClick={this.props.search}
                    >
                      Tìm kiếm
                    </Button>
                  </div>
                </>
              ) : (
                <>
                  <div className="text-no-data">Chưa có thông tin</div>

                  <div style={{ display: "flex", justifyContent: "center" }}>
                    <Button
                      type="primary"
                      className="search-result-button"
                      onClick={this.props.search}
                    >
                      Tìm kiếm
                    </Button>
                  </div>
                </>
              )}
            </div>
          </Tabs.TabPane>
        </Tabs>
      </div>
    );
  }
}
